<template>
    <section class="buscador-productos">
        <!-- Móvil: input grande + lista táctil de resultados -->
        <div v-if="esMovil">
            <b-field label="Buscar producto por nombre o código de barras">
                <b-input
                    v-model="producto"
                    id="producto"
                    size="is-large"
                    icon="magnify"
                    icon-right="barcode-scan"
                    placeholder="Escribe el nombre o código de barras"
                    @input="buscarProductos"
                    expanded
                />
            </b-field>

            <div
                class="lista-resultados-movil"
                v-if="productosEncontrados.length"
            >
                <button
                    type="button"
                    class="fila-producto"
                    v-for="opcion in productosEncontrados"
                    :key="opcion.id"
                    @click="seleccionarProducto(opcion)"
                >
                    <div class="fila-info">
                        <span class="fila-nombre">{{ opcion.nombre }}</span>
                        <span class="fila-detalle">
                            <span v-if="opcion.codigo">Código: {{ opcion.codigo }}</span>
                            <span v-if="opcion.existencia !== undefined"> · Stock: {{ formatoMonto(opcion.existencia) }}</span>
                            <span v-if="opcion.paquetes && opcion.paquetes.length">
                                · Producto empaquetado: {{ descripcionEnvases(opcion.paquetes) }}
                            </span>
                            <span v-if="opcion.paquetes_de">
                                · {{ descripcionEnvaseDe(opcion.paquetes_de) }}
                            </span>
                        </span>
                    </div>
                    <div class="fila-precio">
                        <span v-if="opcion.precioVenta !== undefined">${{ formatoMonto(opcion.precioVenta) }}</span>
                        <b-icon icon="chevron-right" size="is-medium"></b-icon>
                    </div>
                </button>
                <p class="has-text-centered is-size-7 has-text-grey py-2">
                    Toca un producto para agregarlo
                </p>
            </div>
            <p class="has-text-centered is-size-7 has-text-grey py-2" v-else-if="buscando">
                Buscando…
            </p>
        </div>

        <!-- Escritorio: autocomplete con dropdown -->
        <b-field v-else label="Buscar producto por nombre o código de barras">
            <b-autocomplete
                v-model="producto"
                id="producto"
                placeholder="Escribe el nombre o el código de barras del producto"
                :keep-first="true"
                :data="productosEncontrados"
                field="nombre"
                @input="buscarProductos"
                @select="seleccionarProducto"
                size="is-large"
            >
                <template slot-scope="props">
                    <div>
                        <span>{{ props.option.nombre }}</span>
                        <span v-if="props.option.precioVenta !== undefined" class="has-text-grey is-size-7">
                            &mdash; Precio: ${{ formatoMonto(props.option.precioVenta) }}
                        </span>
                        <span v-if="props.option.paquetes && props.option.paquetes.length" class="has-text-info is-size-7" style="display:block">
                            Producto empaquetado: {{ descripcionEnvases(props.option.paquetes) }}
                        </span>
                        <span v-if="props.option.paquetes_de" class="has-text-grey is-size-7" style="display:block">
                            {{ descripcionEnvaseDe(props.option.paquetes_de) }}
                        </span>
                    </div>
                </template>
            </b-autocomplete>
        </b-field>
    </section>
</template>
<script>
    import HttpService from '../../Servicios/HttpService'
    import Utiles from '../../Servicios/Utiles'

    const LIMITE_RESULTADOS = 20
    const DEBOUNCE_MS = 300

    export default {
        name: "BuscarProducto",

        data:()=>({
            producto: "",
            productosEncontrados: [],
            esMovil: false,
            mediaQuery: null,
            timerBusqueda: null,
            buscando: false
        }),

        mounted(){
            this.ponerFocus()

            // Detección reactiva de pantallas móviles
            const mq = window.matchMedia('(max-width: 767px)')
            this.esMovil = mq.matches
            this.mediaQuery = mq
            if (mq.addEventListener) {
                mq.addEventListener('change', this.onCambioPantalla)
            } else if (mq.addListener) {
                mq.addListener(this.onCambioPantalla)
            }
        },

        beforeDestroy() {
            if (this.timerBusqueda) clearTimeout(this.timerBusqueda)

            if (this.mediaQuery) {
                if (this.mediaQuery.removeEventListener) {
                    this.mediaQuery.removeEventListener('change', this.onCambioPantalla)
                } else if (this.mediaQuery.removeListener) {
                    this.mediaQuery.removeListener(this.onCambioPantalla)
                }
            }
        },

        methods: {
            formatoMonto(valor) {
                return Utiles.formatoMonto(valor)
            },
            onCambioPantalla(evento) {
                this.esMovil = evento.matches
            },
            seleccionarProducto(opcion) {
                if(!opcion) return

                this.$emit("seleccionado", opcion)
                this.productosEncontrados = []
                this.ponerFocus()
                setTimeout(() => this.producto = '', 10)
            },

            /**
             * Resumen de las vinculaciones de envase de un producto.
             * Muestra cuántas unidades rinde cada envase: sin el ratio el operador no
             * puede saber si al vender de más se abrirá un envase y cuánto sumará.
             */
            descripcionEnvases(paquetes) {
                if (!Array.isArray(paquetes) || paquetes.length === 0) return ''

                return paquetes
                    .map(p => {
                        const unidades = Utiles.redondearCantidad(Utiles.unidadesPorEnvase(p))
                        const aviso = unidades < 1 ? ' ⚠ vinculación inválida' : ''
                        return p.nombre_paquete + ' (stock ' + p.existencia_paquete + ' · 1 = ' + unidades + ' unid' + aviso + ')'
                    })
                    .join(', ')
            },

            /**
             * Relacion en el sentido INVERSO: el producto que se esta eligiendo ES el
             * producto empaquetado de otro (el que se vende suelto, el producto detal). Sin
             * este texto el operador que busca el empaquetado no ve con que producto se
             * relaciona ni cuantas unidades rinde.
             */
            descripcionEnvaseDe(paquete) {
                if (!paquete) return ''

                const unidades = Utiles.redondearCantidad(Utiles.unidadesPorEnvase(paquete))
                const base = paquete.nombre_base || 'el producto detal'
                const unidad = paquete.unidad_base || 'unidad'
                const aviso = Utiles.puedeAbrirEnvase(paquete) ? '' : ' ⚠ vinculación inválida'

                return 'Es producto empaquetado de ' + base + ' · 1 = ' + unidades + ' ' + unidad + aviso
            },

            buscarProductos() {
                if (this.timerBusqueda) clearTimeout(this.timerBusqueda)

                if (!this.producto || !this.producto.trim()) {
                    this.productosEncontrados = []
                    this.buscando = false
                    return
                }

                this.timerBusqueda = setTimeout(() => this.ejecutarBusqueda(), DEBOUNCE_MS)
            },

            ejecutarBusqueda() {
                const termino = this.producto.trim()
                if (!termino) return

                this.buscando = true

                let payload = {
                    accion: 'obtener_nombre_codigo',
                    producto: termino
                }

                HttpService.obtenerConConsultas('productos.php', payload)
                    .then(productos => {
                        this.productosEncontrados = (Array.isArray(productos) ? productos : []).slice(0, LIMITE_RESULTADOS)
                        this.buscando = false
                    })
                    .catch(() => { this.buscando = false })
            },

            ponerFocus(){
                document.querySelector("#producto").focus()
            }
        }
    }
</script>

<style scoped>
    .buscador-productos {
        width: 100%;
        min-width: 0;
    }

    .buscador-productos .field {
        width: 100%;
    }

    .lista-resultados-movil {
        width: 100%;
        box-sizing: border-box;
        border: 1px solid #dbdbdb;
        border-radius: 8px;
        background: #fff;
        max-height: min(55vh, 28rem);
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
    }

    .fila-producto {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        min-height: 56px;
        box-sizing: border-box;
        gap: 12px;
        padding: 14px 16px;
        border: none;
        border-bottom: 1px solid #f5f5f5;
        background: transparent;
        text-align: left;
        cursor: pointer;
        font-family: inherit;
    }

    .fila-producto:last-child { border-bottom: none; }

    .fila-producto:active,
    .fila-producto:focus {
        background: #dbe4fd;
        outline: none;
    }

    .fila-info {
        display: flex;
        flex-direction: column;
        min-width: 0;
        margin-right: 8px;
    }

    .fila-nombre {
        font-size: 16px;
        font-weight: 600;
        color: #363636;
        overflow-wrap: anywhere;
        line-height: 1.25;
    }

    .fila-detalle {
        font-size: 13px;
        color: #7a7a7a;
        margin-top: 3px;
        line-height: 1.3;
    }

    .fila-precio {
        display: flex;
        align-items: center;
        gap: 2px;
        flex: 0 0 auto;
        font-size: 15px;
        font-weight: 600;
        color: #3e8ed0;
        white-space: nowrap;
    }

    @media (max-width: 380px) {
        .fila-producto {
            gap: 8px;
            padding: 12px 10px;
        }

        .fila-detalle {
            font-size: 12px;
        }

        .fila-precio {
            font-size: 14px;
        }
    }
</style>
